import {
  OPT_WORKFLOWS_LIST_STATUS_ALL_VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ALL__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE,
  POLLING_MAX_INTERVAL,
  POLLING_MAX_ITERATION
} from 'Constants/'
import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import {
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow
} from 'mailup-web-components'
import {
  checkCanCreate,
  copyWorkflow,
  deleteWorkflow,
  getMessagesList,
  getStatusOfWelcomeMessage,
  getTags,
  getWorkflow,
  getWorkflowsList,
  setEnableWorkflow,
  simulateAsync,
  simulateWorkflow
} from 'Pages/WorkflowsList/recoil/actions/actions'
import { modalActivateSimulateState } from 'Pages/WorkflowsList/recoil/state/modalActivateSimulate'
import { pageState } from 'Pages/WorkflowsList/recoil/state/page'
import { tagsState } from 'Pages/WorkflowsList/recoil/state/search'
import {
  modalCopy,
  modalDelete,
  modalSimulate,
  modalStatus
} from '../state/modals'
import {
  messagesState,
  orderingState,
  paginationState,
  searchResult,
  searchState,
  toggleStatusState
} from '../state/search'
import { pendoTrack } from 'Helpers/pendoTracking'

async function doFetch(
  set,
  init,
  searchParams,
  pageNumber,
  pageSize,
  orderBy,
  orderDescending
) {
  if (init) {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      loaded: false
    }))
  } else {
    set(pageState, (prev) => ({
      ...prev,
      fetchingResults: true,
      error: false
    }))
  }

  try {
    const params = {
      pageNumber,
      pageSize,
      orderBy,
      orderDescending
    }

    const bodyParams = {}

    if (searchParams.searchText !== '') {
      bodyParams.SearchText = searchParams.searchText
    }
    if (searchParams.status !== OPT_WORKFLOWS_LIST_STATUS_ALL_VALUE) {
      bodyParams.Status = searchParams.status
    }
    if (searchParams.type !== OPT_WORKFLOWS_LIST_TYPE_ALL__VALUE) {
      bodyParams.Type = searchParams.type
    }
    if (searchParams.tagIds.length) {
      bodyParams.TagIds = searchParams.tagIds
    }
    if (searchParams.filterMessages.length) {
      bodyParams.IdMessagesEmail = searchParams.filterMessages
    }

    const [{ Result: canCreateTrigger }, messages, res, tags] =
      await Promise.all([
        checkCanCreate(),
        getMessagesList(),
        getWorkflowsList(params, bodyParams),
        getTags()
      ])

    set(pageState, (prev) => ({
      ...prev,
      canCreateTrigger,
      isEmptyState: res.TotalItems === 0 && Object.keys(bodyParams).length === 0
    }))
    set(messagesState, messages)
    set(searchResult, (prev) => ({
      ...prev,
      items: res.Items
    }))
    set(paginationState, (prev) => ({
      ...prev,
      totalItems: res.TotalItems
    }))
    set(tagsState, tags)
  } catch (error) {
    logAppError({
      appError: error
    })
    set(pageState, (prev) => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  if (init) {
    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true
    }))
  } else {
    set(pageState, (prev) => ({
      ...prev,
      fetchingResults: false
    }))
  }
}

export const searchWorkflowsCallback =
  ({ snapshot, set }) =>
  async (init = false) => {
    const searchParams = await snapshot.getPromise(searchState)
    const { pageNumber, pageSize } = await snapshot.getPromise(paginationState)
    const { orderBy, orderDescending } =
      await snapshot.getPromise(orderingState)

    await doFetch(
      set,
      init,
      searchParams,
      pageNumber,
      pageSize,
      orderBy,
      orderDescending
    )
  }

export const pageChangeCallback =
  ({ snapshot, set }) =>
  async (pageNumber) => {
    const searchParams = await snapshot.getPromise(searchState)
    const { pageSize } = await snapshot.getPromise(paginationState)
    const { orderBy, orderDescending } =
      await snapshot.getPromise(orderingState)
    set(paginationState, (prev) => ({
      ...prev,
      pageNumber
    }))

    await doFetch(
      set,
      false,
      searchParams,
      pageNumber,
      pageSize,
      orderBy,
      orderDescending
    )
  }

export const changeColumnsOrderCallback =
  ({ snapshot, set }) =>
  async (field) => {
    const searchParams = await snapshot.getPromise(searchState)
    const { pageSize } = await snapshot.getPromise(paginationState)
    const { orderDescending: orderDescendingPrev } =
      await snapshot.getPromise(orderingState)
    const pageNumber = 1
    const orderBy = field
    const orderDescending = !orderDescendingPrev
    set(orderingState, (prev) => ({
      ...prev,
      orderBy,
      orderDescending
    }))
    set(paginationState, (prev) => ({
      ...prev,
      pageNumber
    }))

    await doFetch(
      set,
      false,
      searchParams,
      pageNumber,
      pageSize,
      orderBy,
      orderDescending
    )
  }

export const pageSizeChangeCallback =
  ({ snapshot, set }) =>
  async (pageSize) => {
    const searchParams = await snapshot.getPromise(searchState)
    const { orderBy, orderDescending } =
      await snapshot.getPromise(orderingState)

    set(paginationState, (prev) => ({
      ...prev,
      pageSize
    }))

    await doFetch(
      set,
      false,
      searchParams,
      1,
      pageSize,
      orderBy,
      orderDescending
    )
  }

export const resetSearchCallback =
  ({ reset, set, snapshot }) =>
  async () => {
    reset(searchState)
    reset(searchResult)
    reset(paginationState)
    set(pageState, (prev) => ({
      ...prev,
      loaded: false,
      isEmptyState: false
    }))
  }

export const setStatusWorkflowCallback =
  ({ set, snapshot }) =>
  async (idWorkflow, status, init = false, type) => {
    if (init) {
      set(toggleStatusState(idWorkflow), (prev) => ({
        ...prev,
        statusToggle: status
      }))
    }

    if (!init) {
      set(pageState, (prev) => ({
        ...prev,
        loading: true
      }))

      const { WelcomeMsgEnabled } = await getStatusOfWelcomeMessage()

      // In caso di attivazione welcomeSeries: se status welcomeSeries non attiva, apre modale di redirect ad attivazione
      if (
        !!status &&
        type === OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE &&
        !WelcomeMsgEnabled
      ) {
        set(modalStatus, (prev) => ({
          ...prev,
          show: true,
          idWorkflow
        }))
      } else if (
        !!status &&
        type === OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE
      ) {
        try {
          const wf = await getWorkflow(idWorkflow)

          set(modalActivateSimulateState, {
            idWorkflow,
            mode: 'activate',
            show: true,
            recipientLimit: wf.RecipientLimit || 0
          })
        } catch (error) {
          logAppError({
            Component: 'WorkflowsList',
            Method: 'setStatusWorkflowCallback',
            appError: error
          })
        }

        //
      } else {
        try {
          await setEnableWorkflow(idWorkflow, { Enable: status })
          if (status) {
            pendoTrack('Workflow Active', {})
          }
          set(toggleStatusState(idWorkflow), (prev) => ({
            ...prev,
            statusToggle: status
          }))
          const toastText = status
            ? 'Load.AutomationWorkflow.SuccessEnable'
            : 'Load.AutomationWorkflow.SuccessDisable'
          toastShow(
            getIntl().formatMessage({
              id: toastText
            }),
            TOAST_VARIANT_SUCCESS,
            'simulateAsyncTaskCallbackKO'
          )
        } catch (error) {
          logAppError({
            Component: 'WorkflowsList',
            Method: 'setStatusWorkflowCallback',
            appError: error
          })
          set(toggleStatusState(idWorkflow), {
            error: getIntl().formatMessage({
              id: 'Load.EmailSenderSelector.EmailWarningSave'
            }),
            severity: 'danger'
          })
        }
      }
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }

export const copyWorkflowCallback =
  ({ set, snapshot, reset }) =>
  async (idWorkflow) => {
    set(modalCopy, (prev) => ({
      ...prev,
      fetchData: true
    }))

    const searchParams = await snapshot.getPromise(searchState)
    const { pageNumber, pageSize } = await snapshot.getPromise(paginationState)
    const { orderBy, orderDescending } =
      await snapshot.getPromise(orderingState)

    try {
      const res = await copyWorkflow(idWorkflow)

      if (res.Result) {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Alerts.SuccessCopy'
          }),
          TOAST_VARIANT_SUCCESS,
          'copyWorkflowCallbackOK'
        )
        reset(modalCopy)
        await doFetch(
          set,
          false,
          searchParams,
          pageNumber,
          pageSize,
          orderBy,
          orderDescending
        )
      } else {
        reset(modalCopy)
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Alerts.ErrorGeneric'
          }),
          TOAST_VARIANT_ERROR,
          'copyWorkflowCallbackKO'
        )
        reset(modalCopy)
      }
    } catch (error) {
      reset(modalCopy)
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({
          id: 'Load.AutomationWorkflow.AlertMessageCopyError'
        }),
        severity: 'danger'
      }))
    }
  }

export const simulateCallback =
  ({ set }) =>
  async (idWorkflow) => {
    try {
      const res = await simulateWorkflow(idWorkflow)

      set(modalSimulate, (prev) => ({
        ...prev,
        idSimulate: res.Result
      }))
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const simulateAsyncTaskCallback =
  ({ set, snapshot }) =>
  async (idSimulate) => {
    const { currentIteration } = await snapshot.getPromise(modalSimulate)
    try {
      const res = await simulateAsync(idSimulate)

      const m = JSON.parse(res.Metadata)
      let p = 'TotalCount' in m ? m.TotalCount : undefined
      let d = 'Discarded' in m ? m.Discarded : undefined

      if (currentIteration >= POLLING_MAX_ITERATION || res.Status === 'Error') {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Alerts.TaskSimulationError'
          }),
          TOAST_VARIANT_ERROR,
          'simulateAsyncTaskCallbackKO'
        )
        p = '-'
        d = '-'
      }

      set(modalSimulate, (prev) => ({
        ...prev,
        currentIteration: prev.currentIteration + 1,
        interval: Math.min(prev.interval * 2, POLLING_MAX_INTERVAL),
        simulateStatus: res.Status,
        simulateTotalCount: p,
        simulateDiscarded: d
      }))
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const deleteWorkflowCallback =
  ({ set, snapshot, reset }) =>
  async (idWorkflow) => {
    const searchParams = await snapshot.getPromise(searchState)
    const { pageNumber, pageSize } = await snapshot.getPromise(paginationState)
    const { orderBy, orderDescending } =
      await snapshot.getPromise(orderingState)

    try {
      const res = await deleteWorkflow(idWorkflow)

      if (res.Result) {
        reset(modalDelete)
        await doFetch(
          set,
          false,
          searchParams,
          pageNumber,
          pageSize,
          orderBy,
          orderDescending
        )
        toastShow(
          getIntl().formatMessage({
            id: 'Load.AutomationWorkflow.AlertMessageDeleteSuccess'
          }),
          TOAST_VARIANT_SUCCESS,
          'deleteCallbackOK'
        )
      }
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const filterMessagesCallback =
  ({ set, snapshot }) =>
  async (filterBy) => {
    set(messagesState, (prev) => ({
      ...prev,
      loading: true
    }))
    const { items, count } = await getMessagesList(filterBy)
    set(messagesState, (prev) => ({
      ...prev,
      loading: false,
      items,
      count
    }))
  }

export const resetPageCallback =
  ({ reset }) =>
  async () => {
    reset(modalActivateSimulateState)
  }
